import {
	selectResolvedSku,
	selectShippingInfo
} from '@pdp/data-access/state';

import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectPageType } from '@state/data-access';
import { take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})

export class ProductSelectionStateService {
	resolvedSkuSubscription: Subscription;

	constructor(
		private store: Store
	) {}


	getResolvedSkuData() {
		this.resolvedSkuSubscription = this.store
			.select(selectResolvedSku)
			.subscribe((resolvedSkuData) => resolvedSkuData);
	}

	getShippingInfoData() {
		let shippingInfoData$;
		this.store
			.select(selectShippingInfo)
			.pipe(take(5))
			.subscribe((resolvedSkuData) => shippingInfoData$ = resolvedSkuData);
		return shippingInfoData$;
	}

	getPageTypeData() {
		let pageTypeData$;
		this.store
			.select(selectPageType)
			.pipe(take(5))
			.subscribe((pageTypeData) => pageTypeData$ = pageTypeData);
		return pageTypeData$;
	}

}
